import "./styles/App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGamepad } from "@fortawesome/free-solid-svg-icons";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faBluesky } from "@fortawesome/free-brands-svg-icons";
import logo from "./images/Logo.png";

import {
    Card,
    CardBody,
    CardHeader,
    CardText,
    CardTitle,
    Container,
    Col,
    Row,
    Navbar,
    Nav,
} from "react-bootstrap";

import GameCard from "./components/GameCard";

function App() {
    return (
        <div>
            <div className='App'>
                <Navbar
                    style={{
                        backgroundColor: "#131416",
                        minHeight: "100px",
                        width: "100%",
                    }}
                    expand='lg'
                    variant='dark'
                >
                    <Container>
                        <Navbar.Brand
                            href='#home'
                            style={{ color: "white", marginRight: "-150px" }}
                        >
                            <Row>
                                <Col xs='4' style={{ padding: "0" }}>
                                    <img
                                        src={logo}
                                        alt='Logo'
                                        width={75}
                                        height={75}
                                    />{" "}
                                </Col>
                                <Col
                                    xs='5'
                                    style={{
                                        textAlign: "left",
                                        alignContent: "center",
                                        padding: "0",
                                        color: "white",
                                    }}
                                >
                                    <Col xs='12'>HyperQuest</Col>
                                    <Col xs='12'>Games</Col>
                                </Col>
                            </Row>
                        </Navbar.Brand>
                        {/* <Navbar.Toggle aria-controls='basic-navbar-nav' /> */}
                        <Navbar.Collapse id='basic-navbar-nav'>
                            <Nav className='ml-auto'>
                                {/* <Nav.Link href='#home'>HOME</Nav.Link> */}
                                {/* <Nav.Link href='#steam'>CONTACT</Nav.Link> */}
                                {/* <Nav.Link href='#twitter'>TWITTER</Nav.Link> */}
                                {/* <Nav.Link href='#discord'>DISCORD</Nav.Link> */}
                                {/* <Nav.Link href='#contact'>CONTACT</Nav.Link> */}
                                {/* <Nav.Link href='#other-games'>GAMES</Nav.Link> */}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                {/* <FontAwesomeIcon icon={faGamepad} /> */}
                <br />
                <Col xs='10' sm='8' md='10' lg='6' xl='4'>
                    <hr />
                    <h2>SOCIALS</h2>
                    <hr />
                </Col>
                <Row style={{ fontSize: "calc(1.25rem + 1.5vw)" }}>
                    <Col xs='12'>
                        <a
                            className='social-icon'
                            target='_blank'
                            rel='noreferrer'
                            href='https://bsky.app/profile/hyperquestgames.bsky.social'
                        >
                            <FontAwesomeIcon icon={faBluesky} />
                            {"  "}
                        </a>
                        <a
                            className='social-icon'
                            target='_blank'
                            rel='noreferrer'
                            href='https://twitter.com/Hyperquest2515'
                        >
                            <FontAwesomeIcon icon={faXTwitter} />
                            {"  "}
                        </a>
                        <a
                            className='social-icon'
                            target='_blank'
                            rel='noreferrer'
                            href='https://www.youtube.com/channel/UC7YjEqe-WEzLk7nc5DAmyTw'
                        >
                            <FontAwesomeIcon icon={faYoutube} />{" "}
                        </a>
                        <a
                            className='social-icon'
                            target='_blank'
                            rel='noreferrer'
                            href='https://www.tiktok.com/@hyperquestgames'
                        >
                            <FontAwesomeIcon icon={faTiktok} />{" "}
                        </a>
                        <a
                            className='social-icon'
                            target='_blank'
                            rel='noreferrer'
                            href='https://www.facebook.com/profile.php?id=61551895658757'
                        >
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                        <a
                            className='social-icon'
                            target='_blank'
                            rel='noreferrer'
                            href='https://www.instagram.com/hyperquest_games'
                        >
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                    </Col>
                    <Col
                        xs='12'
                        style={{
                            fontSize: "1.25rem",
                            marginTop: "12px",
                        }}
                    >
                        <a href='mailto: hyperquestgames@gmail.com'>
                            hyperquestgames@gmail.com
                        </a>
                    </Col>
                </Row>
                <br />
                <br />
                <Col xs='10' sm='8' md='10' lg='6' xl='4'>
                    <hr />
                    <h2>GAMES</h2>
                    <hr />
                </Col>
                <Row
                    style={{
                        marginTop: "25px",
                        width: "100%",
                        justifyContent: "center",
                    }}
                >
                    <GameCard
                        title='RIFT DRIFT'
                        image='./images/Rift Drift Itch Cover.png'
                        description='Rift Drift is a procedurally generated Infinite Drifter.'
                        links={[
                            [
                                "Wishlist on Steam!",
                                "https://store.steampowered.com/app/3238290/Rift_Drift/?beta=0",
                            ],
                            [
                                "Play The Prototype",
                                "https://hyperquest-games.itch.io/rift-drift-prototype",
                            ],
                        ]}
                    />
                    <GameCard
                        title='MICRO ROGUE'
                        image='./images/Micro Rogue.png'
                        description='Micro Rogue is a survivors-like dungeon crawler focussed on tactical auto-combat and an upgrade system utilized by both you and your enemies.'
                        links={[
                            [
                                "Wishlist on Steam!",
                                "https://store.steampowered.com/app/2534850/Micro_Rogue/",
                            ],
                            [
                                "Play The Prototype",
                                "https://hyperspace-wizard.itch.io/micro-rogue-jam",
                            ],
                        ]}
                    />
                    <GameCard
                        title='SPINNER'
                        image='./images/Spinner Thumbnail.png'
                        description='Spinner is a one touch arcade mobile game. Test your reflexes and set a new highscore.'
                        links={[
                            [
                                "Download on Google Play",
                                "https://play.google.com/store/apps/details?id=com.HyperQuestGames.Spinner",
                            ],
                        ]}
                    />
                </Row>
            </div>
        </div>
    );
}

export default App;
